export const entity = {
    name: "GeneralSettings",
    fields: [
        "Month",
        "MonthNumber",
        {path: "delay", type: "integer"},
        {
            path: 'fiscalYearStart',
            fieldPath: ['month.id', 'monthNumber.id'],
            $f: (object, context, callback) => {
                return callback(null, object.month?.id + '-' + object.monthNumber?.id)
            }
        }
    ]
}

export const module_ = {
    object: "GeneralSettings",
    tKey: "mTitle_generalSettings",
    category: {
        path: 'setting',
        icon: 'settings'
    },
    defaultPanel: 'form',
    newable: false,
    removable: false,
    listable: false,
    viewMap: {
        dt: [
            {path: 'month'},
            {path: "monthNumber"}
        ],
        form: [
            {path: "delay", required: true, default: 1},
            {path: 'month', sortList: false, required: true},
            {path: "monthNumber", display: "dayNumber", tKey: "day", sortList: false, required: true},
        ]
    }
}
